export function parsePrice (unit_amount) {
    return `$${`${unit_amount}`.slice(null, -2)}${`${unit_amount}`.slice(`${unit_amount}`.length-2, `${unit_amount}`.length) !== '00' ? '.'+`${unit_amount}`.slice(`${unit_amount}`.length-2, `${unit_amount}`.length) : ''}`
}